//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axiosApi from "@/request/index";
import footerNav from "@/components/footerNav";
import { Dialog, Toast } from "vant";
import { getDate } from "@/utils/util.js";

export default {
  name: "activities",
  components: {
    footerNav
  },
  data() {
    return {
      showPicker: false,
      sampleSelectSn: "",
      billDate: getDate(new Date()),
      billDate1: getDate(new Date()) + " 00:00:00",
      sampleSelectName: ""
    };
  },
  created() {},
  mounted() {},
  methods: {
    onSubmit() {
      var list = JSON.parse(this.$route.query.itemList);
      var sampleColorDeailList = [];
      list.forEach(item => {
        if (item.checked) {
          sampleColorDeailList.push({ sampleId: item.sampleId });
        }
      });
      this.$refs.vanForm
        .validate()
        .then(res => {
          axiosApi
            .createMocileSample({
              sampleSelectName: this.sampleSelectName,
              billDate: this.billDate1,
              sampleList: sampleColorDeailList
            })
            .then(restuen => {
              this.$router.push({ name: "activitiesSelection" });
            });
        })
        .catch(err => {});
    },
    quxiao() {
      this.$router.push({ name: "centerOrder" });
    },
    onConfirm(time) {
      var year = time.getFullYear();
      var month = time.getMonth() + 1;
      var day = time.getDate();
      if (month < 10) {
        month = "0" + month;
      }
      this.billDate = year + "-" + month + "-" + day;
      this.billDate1 = year + "-" + month + "-" + day + " 00:00:00";
      this.showPicker = false;
    },
    formatter(type, val) {
      if (type === "year") {
        return `${val}年`;
      } else if (type === "month") {
        return `${val}月`;
      }
      return val;
    }
  }
};



// WEBPACK FOOTER //
// ./src/pages/centerOrder/activities.vue